<template>
  <div v-if="previousDateIsOtherDay" class="mb-4">
    <p
      class="mx-auto w-max rounded-sm border-2 border-black-dark p-2 text-xs italic shadow-teal-hard-sm dark:bg-kekkle-dark-light dark:text-slate-200"
    >
      {{ dateString2.slice(0, -5) }}
    </p>
  </div>
  <div class="mb-4">
    <div
      class="flex flex-nowrap items-center justify-start gap-x-2"
      :class="isAuthor ? 'flex-row-reverse' : ''"
    >
      <div
        v-if="authorUuid === 'automatic_report_ai'"
        class="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-linear-to-br from-teal-400 to-cyan-500 shadow"
      >
        <span class="text-lg">🤖</span>
      </div>
      <tiny-user-thumb v-else :uuid="authorUuid"></tiny-user-thumb>
      <p
        :class="isAuthor ? 'ml-8 text-right' : 'mr-8 text-left'"
        class="rounded-lg border-2 border-black-dark p-4 pt-2 pb-0 wrap-break-word shadow-teal-hard-sm dark:bg-kekkle-dark-light dark:text-slate-200"
      >
        <span v-if="!isAuthor" class="text-xs font-bold text-teal"
          >{{ authorName }}
        </span>
        <br v-if="!isAuthor" />
        <span class="wrap-break-word">{{ comment }}</span>
        <br />
        <span class="text-xs text-slate-500 italic dark:text-slate-400">
          {{ getTime(date) }}
        </span>
      </p>
    </div>
  </div>
</template>
<script setup>
import TinyUserThumb from "@/components/TinyUserThumb.vue";
import { computed, defineProps, onBeforeUnmount, ref } from "vue";
import { useAuthStore } from "@/stores/modules/auth/auth";
import { useGroupsStore } from "@/stores/modules/groups/groups";
import { dateTimeAgo } from "@/helpers/dates/date-time-ago";
import { translate } from "@/i18n/vueI18n";
import { dateAgo } from "@/helpers/dates/date-ago";
import { getTime } from "../helpers/dates/get-time";

const authStore = useAuthStore();
const groupsStore = useGroupsStore();

const props = defineProps({
  comment: {
    type: String,
    required: true,
  },
  previousDate: {
    type: Date,
    required: false,
  },
  date: {
    type: Date,
    default: new Date(),
  },
  authorUuid: {
    type: String,
    required: true,
  },
});

let dateString = ref("");
let dateString2 = ref("");

updateTime();
let interval = setInterval(updateTime, 1000);

onBeforeUnmount(() => {
  if (interval) {
    clearInterval(interval);
  }
});

function updateTime() {
  dateString.value = dateTimeAgo(props.date);
  dateString2.value = dateAgo(props.date);
}

let isAuthor = computed(() => {
  return props.authorUuid === authStore.authUuid;
});

const authorName = computed(() => {
  const memberName = groupsStore.groupData?.members?.[props.authorUuid]?.name;

  if (memberName) return memberName;

  if (props.authorUuid === "automatic_report_ai") {
    return translate("global.automatic_report_ai");
  }

  return translate("global.deleted_user");
});

let previousDateIsOtherDay = computed(() => {
  if (props.previousDate) {
    return (
      props.previousDate.getDate() !== props.date.getDate() ||
      props.previousDate.getMonth() !== props.date.getMonth() ||
      props.previousDate.getFullYear() !== props.date.getFullYear()
    );
  } else {
    return true;
  }
});
</script>
